var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"wrap no_side",attrs:{"id":"app"}},[(!_vm.noHeader)?_c('page-header',{attrs:{"type":_vm.type}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }